import React from "react";
import PropTypes from "prop-types";
import {PROP_NAME_COUNTRY} from "./CountryInputComponent";
import {PROP_NAME_POSTAL_CODE} from "./PostalCodeInputComponent";
import {getFormInputCssClass, hasMessage} from "../../../util/FormUtil";

export const PROP_NAME_STATE = "state";

class StateInputComponent extends React.Component {

    constructor(props){
        super(props);
        this.checkField = this.checkField.bind(this);
        this.checkPattern = this.checkPattern.bind(this);
        this.checkRequired = this.checkRequired.bind(this);
        this.setDirty = this.setDirty.bind(this);
        this.setValue = this.setValue.bind(this);
        this.validate = this.validate.bind(this);

        const PROP_DATA = {};
        const {userDataInit: {address: {maxLengthState, patternState}}} = this.props;
        PROP_DATA[PROP_NAME_STATE] = { label: "State/Province/Region", maxLength: maxLengthState, pattern: patternState };
        this.PROP_DATA = PROP_DATA;
    }

    componentDidUpdate(prevProps) {
        const {data, options} = this.props;
        const state = data[PROP_NAME_STATE];

        if (options !== prevProps.options) { // findLocation service may/may not find
            if ((options && options.length > 0)) {
                let index=0;
                  //set state
                  if(state){
                    options.forEach((element,i) => {
                        if(state===element.code){
                            index=i;
                        }
                    });
                  }
                this.setValue(options[index].code);
            }
        }
    }

    setValue(e){
        let value = typeof(e) === "string" ? e : e.target.value;
        this.validate(value);
    }

    validate(value){
        const {required, setFormState} = this.props;
        const statePropInfo = this.PROP_DATA[PROP_NAME_STATE];
        // meta - reset everything
        const newMetadata = {valid: true, dirty: true, message: null};
        this.checkField(value, statePropInfo, newMetadata, required);
        setFormState(
            {property: PROP_NAME_STATE, data: value, metadata: { ...newMetadata }}
        );
    }

    checkRequired(value, propInfo, metadata, required){
        metadata.valid = !required || (value && value.trim().length > 0);
        if (! metadata.valid){
            metadata.message = propInfo.label + " is required";
        }
        return metadata.valid;
    }

    checkPattern(value="", propInfo, metadata){
        const {index} = this.props;
        metadata.valid = propInfo.pattern.test(value);
        if (! metadata.valid){
            metadata.message = propInfo.label + " " + index + " contains invalid characters"
        }
        return metadata.valid;
    }

    checkField(value, propInfo, metadata, required){
        if (this.checkPattern(value, propInfo, metadata)){
            this.checkRequired(value, propInfo, metadata, required);
        }
    }

    setDirty(){
        this.validate(this.props.data[PROP_NAME_STATE]);
    }

    isDisabled(data, readOnly) {
        const countryCode = data[PROP_NAME_COUNTRY];
        const postalCode = data[PROP_NAME_POSTAL_CODE];
        return readOnly || !countryCode || (countryCode === 'US' && !postalCode);
    }

    render(){
        const {data, options, metadata, readOnly, required} = this.props;
        const isSabrixVerified = (options && options.length > 0);
        const state = (data[PROP_NAME_STATE] || "");
        const requiredClassName = required ? "" : " optional";
        const fieldClassNameAttr = getFormInputCssClass(metadata, PROP_NAME_STATE);
        const statePropInfo = this.PROP_DATA[PROP_NAME_STATE];

        return (
            <li className={"grid__col-md-6 grid__col-sm-12" + requiredClassName}>
                <label htmlFor={PROP_NAME_STATE}>{statePropInfo.label}</label>
                {
                    isSabrixVerified &&
                    <select
                        id={PROP_NAME_STATE}
                        name={PROP_NAME_STATE}
                        className={"text-input text-input--large responsive" + fieldClassNameAttr}
                        disabled={this.isDisabled(data,readOnly)}
                        onChange={this.setValue}
                        onBlur={this.setDirty}
                        required={required}
                        value={state}
                    >
                        {(options && options.length > 1) && <option value='' selected disabled >Select a State</option>}
                        {
                            options && options.map(
                                o => (<option value={o.code}>{o.description}</option>)
                            )
                        }
                    </select>
                }
                {
                    !isSabrixVerified &&
                    <input
                        className={"text-input text-input--large responsive" + fieldClassNameAttr}
                        disabled={this.isDisabled(data, readOnly)}
                        id={PROP_NAME_STATE}
                        maxLength={statePropInfo.maxLength}
                        name={PROP_NAME_STATE}
                        onChange={this.setValue}
                        onBlur={this.setDirty}
                        type="text"
                        value={state}
                    />
                }
                {
                    hasMessage(metadata, PROP_NAME_STATE) &&
                    <div className="error">{metadata[PROP_NAME_STATE].message}</div>
                }
            </li>
        );
    }
}


StateInputComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    readOnly: PropTypes.object,
    required: PropTypes.bool.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired
};

export default StateInputComponent;